module.exports = __webpack_public_path__ + "static/media/our-services.16f316f0.jpg";